import _ from "lodash";

export const DEFAULT_FORM_RULES = [
  {
    required: true,
    message: "harus diisi terlebih dahulu!"
  }
];

export const formRules = (label) => {
  if (label) {
    if (label === "email") {
      return [
        {
          required: true,
          type: "email",
          message: `${label} harus diisi dengan format email!`
        }
      ];
    } else if (label === "nomor handphone") {
      return [
        {
          required: true,
          max: 13,
          min: 10,
          message: `${label} harus diisi dengan minimal 10 digit angka dan maksimal 13 digit angka dimulai dengan 08XX`
        }
      ];
    } else if (label === "kata sandi") {
      return [
        {
          required: true,
          pattern: new RegExp(
            /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=])(?=.{8,}).*$/
          ),
          message: `${label} minimal 8 Karakter dan terdapat minimal 1 Huruf Besar(A-Z), 1 Angka(0-9), 1 spesial karakter(@#$%^&+!=).`
        }
      ];
    } else {
      return [
        {
          required: true,
          message: `${label} harus diisi terlebih dahulu!`
        }
      ];
    }
  } else {
    return [
      {
        required: true,
        message: "Harus diisi terlebih dahulu!"
      }
    ];
  }
};

export const MENU_ITEM_KEY = {
  // "app-pmk-importemployee": "partner-employee-plafon",
  // "app-pmk-employee": "partner-employee-data",
  // "app-pmk-transaction": "partner-pinjaman-pengajuan",

  "app-pmk-importemployee": "app-pmk-importemployee",
  "app-pmk-employee": "app-pmk-employee",
  "app-pmk-transaction": "app-pmk-transaction",
  "app-pmk-company": "app-pmk-company",
  "app-personal": "app-personal"
};

export const ALL_USER_ACCESS_MENU = _.keys(MENU_ITEM_KEY).map((value, key) => ({
  accessMenuName: value,
  actions: ["VIEW"]
}));

export const USER_PRODUCT_CATEGORY_ACCESS_KEYS = {
  PMK: "app-pmk"
};
